import CircleMinusFilled from './src/circle-minus-filled';
export default CircleMinusFilled;